import React from 'react'
import { TemplateContainer } from '../../containers/dashboard/template'

export default function EditCompany({accessToken, name, email, isActive, isSuperuser}) {
    return (
    <TemplateContainer pageName={'Edit Company'} email={email} 
    name={name} 
    accessToken={accessToken}
    isActive={isActive}
    isSuperuser={isSuperuser}
    />)
}

